import { render } from "./json-pretty.vue?vue&type=template&id=601a0ccc&scoped=true"
import script from "./json-pretty.vue?vue&type=script&lang=js"
export * from "./json-pretty.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-601a0ccc"

export default script